module.exports = __webpack_public_path__ + "img/soccer.38aaa78a.svg";